import { render, staticRenderFns } from "./FormulaHead.vue?vue&type=template&id=a68f46de&scoped=true"
import script from "./FormulaHead.vue?vue&type=script&lang=js"
export * from "./FormulaHead.vue?vue&type=script&lang=js"
import style0 from "./FormulaHead.vue?vue&type=style&index=0&id=a68f46de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68f46de",
  null
  
)

export default component.exports